import { Injectable } from '@angular/core';
import { BaseSearchStrategy } from './base-strategy';
import { SearchableItem } from '../models/searchable-item.model';
import {
  ScoredMatch,
  StrategyContext,
  StrategyId,
} from '../models/search-strategy.model';

@Injectable({ providedIn: 'root' })
export class SemanticMatchStrategy extends BaseSearchStrategy {
  readonly id: StrategyId = 'semantic';
  readonly defaultWeight = 30; // per matched expanded term
  private readonly cap = 100;

  override score<T>(
    item: SearchableItem<T>,
    ctx: StrategyContext
  ): ScoredMatch | null {
    if (ctx.expandedTerms.size === 0) return null;
    const title = this.normalizedTitle(item);
    const desc = this.normalizedDescription(item);
    const keywords = this.normalizedKeywords(item);

    let hits = 0;
    let evidence: string | undefined;
    for (const term of ctx.expandedTerms) {
      if (term === ctx.normalizedQuery) continue; // raw query already handled by other strategies
      if (
        title.includes(term) ||
        desc.includes(term) ||
        keywords.some((k) => k.includes(term))
      ) {
        hits++;
        if (!evidence) evidence = term;
      }
    }

    const raw = hits * this.defaultWeight;
    const capped = Math.min(raw, this.cap);
    return this.match(this.id, capped, evidence);
  }
}
